var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.mobileCheck())?_c('div',[_c('PageHeader'),_c('Header'),_c('router-view',{staticClass:"Content"}),_c('Footer')],1):_c('div',[_c('Header'),_c('router-view',{staticClass:"mcontent"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }